import { render } from "./Admin.vue?vue&type=template&id=a9d34aa2"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
script.render = render

export default script